import { useState } from "react"
import { Container, Row, Col } from "react-bootstrap";

import contactImg from '../../assets/img/contact-img.png';
import emailjs from '@emailjs/browser';

export const Contact = ({ language }) => {

    const isChinese = language === "Chinese";

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [message, setMessage] = useState("");


    const [sending, setSending] = useState(false);
    const [status, setStatus] = useState({});

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSending(true);

        const templateParams = {
            firstName: firstName,
            lastName: lastName,
            phone: phone,
            email: email,
            message: message,
        }
        
        const serviceID = process.env.REACT_APP_SERVICE_ID;
        const templateID = process.env.REACT_APP_TEMPLATE_ID;
        const publicKey = process.env.REACT_APP_PUBLIC_KEY;


        emailjs.send(serviceID, templateID, templateParams, publicKey)
            .then((res) => {
                setFirstName('');
                setLastName('');
                setPhone('');
                setEmail('');
                setMessage('');
                setStatus({ success: true, message: "sent" });
            })
            .catch((err) => {
                setStatus({ success: false, message: "error" });
        })
        setSending(false);
    }

    return (
        <section className="contact" id="connect">
            <Container>
                <Row className="align-items-center">
                    <Col md={4}>
                        <img src={contactImg} alt={isChinese ? "聯絡我們" : "Contact us"} />
                    </Col>
                    <Col md={8}>
                        <h2>{isChinese ? "聯絡我們" : "Get in Touch"}</h2>
                        <form onSubmit={handleSubmit}>
                            <Row>
                                <Col sm={6} className="px-1">
                                    <input required type="text" value={firstName} placeholder={isChinese ? "名字" : "First name"} onChange={(e) => setFirstName(e.target.value)} />
                                </Col>
                                <Col sm={6} className="px-1">
                                    <input required type="text" value={lastName} placeholder={isChinese ? "姓氏" : "Last name"} onChange={(e) => setLastName(e.target.value)} />
                                </Col>
                                <Col sm={6} className="px-1">
                                    <input required type="email" value={email} placeholder={isChinese ? "電子郵件" : "Email"} onChange={(e) => setEmail(e.target.value)} />
                                </Col>
                                <Col sm={6} className="px-1">
                                    <input required type="tel" value={phone} placeholder={isChinese ? "電話" : "Phone"} onChange={(e) => setPhone(e.target.value)} />
                                </Col>
                                <Col>
                                    <textarea required rows="6" sm={12} value={message} placeholder={isChinese ? "留言內容" : "Message"} onChange={(e) => setMessage(e.target.value)}></textarea>
                                    <button type="submit"><span>{sending ? (isChinese ? "傳送中..." : "Sending...") : (isChinese ? "送出" : "Send")}</span></button>
                                </Col>
                                {
                                    status.message && 
                                        <Col>
                                            <p className={status.success === false ? "danger" : "success"}>
                                                {status.success
                                                    ? (isChinese ? "訊息已成功送出。" : "Your message has been sent.")
                                                    : (isChinese ? "發生錯誤，請稍後再試。" : "Something went wrong. Please try again later.")}
                                            </p>
                                        </Col>
                                }
                            </Row>
                        </form>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}